import ConfigForm from './ConfigForm.jsx';

const SCHEMA = [
  { key: 'item_type', label: 'Item type', kind: 'select', options: ['string', 'integer', 'number', 'boolean'] },
  { key: 'placeholder', label: 'Placeholder', kind: 'text' },
  { key: 'min_items', label: 'Min items', kind: 'integer' },
  { key: 'max_items', label: 'Max items', kind: 'integer' },
];

export default function ScalarListConfig({ field, onConfigChange }) {
  return <ConfigForm schema={SCHEMA} config={field.config} onConfigChange={onConfigChange} />;
}
